export const IsNarrator = (): boolean => {
    return JSON.parse(localStorage.getItem('isNarrator') || '{}');
};
